import axios from "axios";

export default {
  pages(locale) {
    return axios.post("/api/query", {
      query: "site.children.listed",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
      },
    });
  },
  newsletter(locale) {
    return axios.post("/api/query", {
      query: "site",
      select: {
        nintro: `site.content('${locale}').nintro.kirbytext`,
        nextra: `site.content('${locale}').nextra.kirbytext`,
      },
    });
  },
  home() {
    return axios.post("/api/query", {
      query: "page('home')",
      select: {
        title: true,
        uid: true,
        special: "page.special",
        link: "page.link",
        floors: {
          query: "page.floors.toStructure",
          select: {
            type: "structureItem.type",
            fontcolor: "structureItem.fontcolor.toBool",
            visible: "structureItem.visible.toBool",
            message: "structureItem.message",
            hover: "structureItem.hover",
            stream: "structureItem.stream",
            link: {
              query: "structureItem.link.toPage",
              select: {
                url: "page.id"
              }
            },
            picture: {
              query: "structureItem.picture.toFile",
              select: {
                thumb: "file.resize(100).url",
                url: "file.resize(1500).url",
                srcset: "file.srcset([600, 800, 1000, 1200, 1600, 2000])",
                focusY: "file.focusPercentageY",
                focusX: "file.focusPercentageX",
              },
            },
            exhibition: {
              query: "structureItem.exhibition.toPage",
              select: {
                title: "page.title",
                subtitle: "page.subtitle",
                uid: "page.uid",
                startdate: "page.startdate.toDate('d.m.Y')",
                enddate: "page.enddate.toDate('d.m.Y')",
                hideenddate: "page.hideenddate.toBool()",
                location: "page.location",
                video: {
                  query: "page.videos.first",
                  select: {
                    url: "file.url",
                  },
                },
                cover: {
                  query: "page.cover.toFile",
                  select: {
                    thumb: "file.resize(100).url",
                    url: "file.resize(1500).url",
                    srcset: "file.srcset([600, 800, 1000, 1200, 1600, 2000])",
                    focusY: "file.focusPercentageY",
                    focusX: "file.focusPercentageX",
                  },
                },
              },
            },
          },
        },
      },
    });
  },
  program() {
    return axios.post("/api/query", {
      query: "page('program').children.listed.sortBy('enddate', 'desc')",
      select: {
        title: true,
        subtitle: true,
        uid: true,
        current: "page.current.toBool()",
        recording: {
          query: "page.recording.toPage",
          select: {
            uid: "page.uid",
            vimeoid: "page.videolink",
            type: "page.type",
            title: true,
            talktitle: "page.talktitle",
            template: "page.parent.intendedTemplate",
            parent: "page.parent.uid",
          },
        },
        year: "page.enddate.toDate('Y')",
        startdate: "page.startdate.toDate('d.m.Y')",
        enddate: "page.enddate.toDate('d.m.Y')",
        hideenddate: "page.hideenddate.toBool()",
        showmultiple: "page.showmultiple.toBool()",
        multipledates: "page.multipledates.kt()",
        location: "page.location",
        cover: {
          query: "page.cover.toFile",
          select: {
            thumb: "file.resize(100).url",
            srcset: "file.srcset([300, 600, 900])",
          },
        },
      },
    });
  },
  exhibition(locale, uid) {
    return axios.post("/api/query", {
      query: `page('program').children.find('${uid}')`,
      select: {
        title: `page.content('${locale}').title`,
        subtitle: `page.content('${locale}').subtitle`,
        uid: true,
        year: "page.enddate.toDate('Y')",
        startdate: "page.startdate.toDate('d.m.Y')",
        enddate: "page.enddate.toDate('d.m.Y')",
        hideenddate: "page.hideenddate.toBool()",
        showmultiple: "page.showmultiple.toBool()",
        multipledates: "page.multipledates.kirbytextinline",
        location: "page.location",
        description: `page.content('${locale}').description.kirbytext`,
        credits: `page.content('${locale}').credits.kirbytext`,
        extra: `page.content('${locale}').extra.kirbytext`,
        recording: {
          query: "page.recording.toPage",
          select: {
            uid: "page.uid",
            vimeoid: "page.videolink",
            type: "page.type",
            title: true,
            talktitle: "page.talktitle",
            description: "page.description.kirbytext",
            template: "page.parent.intendedTemplate",
            parent: "page.parent.uid",
          },
        },
        video: {
          query: "page.videos.first",
          select: {
            url: "file.url",
          },
        },
        videocontrols: "page.videoclick.toBool",
        videohome: "page.videohome.toBool",
        cover: {
          query: "page.cover.toFile",
          select: {
            thumb: "file.resize(100).url",
            url: "file.url",
            srcset: "file.srcset([300, 600, 900])",
          },
        },
        first: {
          query: "page.images.filterBy('template', 'image').sortBy('sort','asc').first",
          select: {
            thumb: "file.resize(100).url",
            url: "file.url",
            srcset: "file.srcset([600, 1000, 1200, 1600])",
            caption: "file.caption",
          },
        },
        gallery: {
          query: "page.images.filterBy('template', 'image').sortBy('sort','asc').slice(1)",
          select: {
            thumb: "file.resize(100).url",
            url: "file.url",
            srcset: "file.srcset([600, 1000, 1200, 1600])",
            caption: "file.caption",
          },
        },
      },
    });
  },
  recordings() {
    return axios.post("/api/query", {
      query: "page('recordings').children.listed",
      select: {
        title: true,
        talktitle: "page.talktitle",
        date: "page.date.toDate('d.m.Y')",
        template: "page.intendedTemplate",
        uid: true,
        videos: {
          query: "page.children.listed",
          select: {
            title: true,
            talktitle: "page.talktitle",
            date: "page.date.toDate('d.m.Y')",
            uid: true,
            vimeoid: "page.videolink",
          }
        },
      },
    });
  },
  recording(locale, uid) {
    return axios.post("/api/query", {
      query: `page('recordings').children.find('${uid}')`,
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        talktitle: "page.talktitle",
        date: "page.date.toDate('d.m.Y')",
        location: "page.location",
        description: `page.content('${locale}').description.kirbytext`,
        credits: `page.content('${locale}').credits.kirbytext`,
        videolink: "page.videolink",
      },
    });
  },
  innerrecording(locale, collection, uid) {
    return axios.post("/api/query", {
      query: `page('recordings').children.find('${collection}').children.find('${uid}')`,
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        talktitle: "page.talktitle",
        date: "page.date.toDate('d.m.Y')",
        location: "page.location",
        description: `page.content('${locale}').description.kirbytext`,
        credits: `page.content('${locale}').credits.kirbytext`,
        videolink: "page.videolink",
      },
    });
  },
  venue(locale) {
    return axios.post("/api/query", {
      query: "page('venue')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        text: `page.content('${locale}').text.kirbytext`,
        info: `page.content('${locale}').info.kirbytext`,
        background: {
          query: "page.images.template('cover').first",
          select: {
            thumb: "file.resize(100).url",
            url: "file.resize(1500).url",
            srcset: "file.srcset([600, 800, 1000, 1200, 1600, 2000])",
          },
        },
        gallery: {
          query: "page.images.template('image')",
          select: {
            thumb: "file.resize(100).url",
            url: "file.resize(1500).url",
            srcset: "file.srcset([600, 800, 1000, 1200, 1600, 2000])",
          },
        },
      },
    });
  },
  visit(locale) {
    return axios.post("/api/query", {
      query: "page('visit')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        address: `page.content('${locale}').address.kirbytext`,
        email: "page.email",
        extra: `page.content('${locale}').extra.kirbytext`,
        hours: {
          query: `page.content('${locale}').hours.toStructure`,
          select: {
            days: "structureItem.days",
            hours: "structureItem.hours",
          },
        },
        directions: `page.content('${locale}').directions.kirbytext`,
        price: `page.content('${locale}').price`,
        text: `page.content('${locale}').text.kirbytext`,
        social: `page.content('${locale}').social.kirbytext`,
        background: {
          query: "page.files.first",
          select: {
            thumb: "file.resize(100).url",
            url: "file.resize(1500).url",
            srcset: "file.srcset([600, 800, 1000, 1200, 1600, 2000])",
          },
        },
      },
    });
  },
  privacy(locale) {
    return axios.post("/api/query", {
      query: "page('privacy-policy')",
      select: {
        title: true,
        uid: true,
        text: `page.content('${locale}').text.kirbytext`,
      },
    });
  },
};
